import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IProps {
  url: string;
}

export const UseGetInvoiceCustomLogo = ({ url }: IProps) => useQuery(
  'UseGetInvoiceCustomLogo',
  async () => {
    const res = await httpService.get(`${BASE_URL}${url}`, {
      responseType: 'blob',
    });
    return URL.createObjectURL(res.data);
  },
  {
    enabled: true,
    retry: 1,
    staleTime: 0,
    cacheTime: 0,
    refetchOnWindowFocus: false,
  },
);
